import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MemberBadgeDto } from '@careapp-group/ng-sdk-v2-new';

/**
 * Select member badges
 * Display available badges, with a toggle and a preview next to each.
 * If a role is provided, only badges that can be applied to that role will be shown.
 */
@Component({
  selector: 'ca-select-member-badges',
  templateUrl: './select-member-badges.component.html',
  styleUrls: ['./select-member-badges.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectMemberBadgesComponent {
  _selectedBadgeIds: string[] = [];
  @Input() allBadges: MemberBadgeDto[];
  @Input() set selectedBadgeIds(value: string[]) {
    if (!!value) {
      this._selectedBadgeIds = value;
    }
  }
  @Input() role?: string;
  @Output() badgeToggle = new EventEmitter<{badge: MemberBadgeDto, checked: boolean}>();

  badgesForRoleFilter() {
    return (badge: MemberBadgeDto) => {
      if (!!this.role) {
        // If roles are null or empty, all users can have this badge.
        if (!badge.roles?.length) {
          return true;
        }
        // If the badge contains roles, this permission role must be within the array.
        return badge.roles.includes(this.role);
      }
      // No role has been supplied, all badges can be shown.
      return true;
    };
  }
}
